<div id="modal" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
  <div class="relative p-6 bg-white rounded-lg shadow-lg w-96">
    <button id="modal-close-icon" class="absolute right-4 top-4" (click)="cancel()">
      <span class="text-lg material-symbols-rounded text-grey-800">close</span>
    </button>
    <div class="flex justify-start">
      <div class="flex items-center w-10 h-10 rounded-full" id="check-circle-icon">
        <span class="text-4xl text-green-500 material-symbols-rounded">
          check_circle
        </span>
      </div>
    </div>
    <h2 class="mx-1 mt-2 text-2xl font-medium text-left" id="modal-header">{{modalHeader}}</h2>
    <p class="mx-1 mt-2 text-left" id="modal-text">{{modalText}}</p>
    <div class="flex justify-between mt-6">
      <button (click)="cancel()" class="border border-gray-300 rounded-lg px-4 py-2 w-[calc(50%-0.5rem)] mr-2 hover:bg-gray-100" id="modal-close-button">
        No
      </button>
      <button (click)="confirm()" class="btn btn-primary rounded-lg px-4 py-2 w-[calc(50%-0.5rem)] ml-2" id="modal-confirm-button">
        Yes
      </button>
    </div>
  </div>
</div>
